<template>
  <model-form
    ref="modelForm"
    :model="report"
    modal-type="modal"
    width="800px"
    :close-on-save="false"
    @change="$emit('change')"
  >
    <div>
      <div class="row items-start">
        <q-input
          v-model="report.name"
          class="col-7 q-mr-sm"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          :autofocus="!$q.platform.is.ios"
        />
        <q-select
          v-model="report.reportCategory"
          class="col-4"
          label="Category"
          option-value="id"
          option-label="name"
          map-options
          :options="reportCategories.data"
        />
      </div>
      <div class="row items-start">
        <q-input
          v-if="report.isRemote"
          v-model="report.description"
          class="col-7 q-mr-sm"
          label="Description"
          bottom-slots
        />
        <q-btn
          :icon="report.icon"
          class="col-auto q-py-md"
          style="color: #757575;"
          outline
          label="Icon"
          @click="$refs.iconPickerDialog.show()"
        />
        <q-checkbox
          v-if="currentUser && currentUser.superUser"
          v-model="report.regionReport"
          class="col-auto q-pa-sm"
          label="Region Report"
          bottom-slots
        />
      </div>
      <div
        v-if="report.isLocal"
        class="row q-gutter-sm"
      >
        <q-input
          v-model="report.description"
          class="col"
          type="textarea"
          label="Description"
          bottom-slots
        />
      </div>
    </div>
    <div
      v-if="report.isRemote"
      class="column"
    >
      <div class="text-bold q-mb-md">
        Controls
      </div>

      <div class="row q-gutter-md q-mb-md items-start">
        <q-select
          v-model="report.controls"
          multiple
          use-input
          use-chips
          class="col"
          label="Controls"
          :options="$_.map(report.allControls, name => { return { label: $_.startCase(name), value: name } })"
          option-label="label"
          option-value="value"
          emit-value
          map-options
          bottom-slots
          @keyup.enter.stop
        />
        <q-btn
          class="q-ma-md q-pa-none q-px-sm"
          size="sm"
          outline
          label="Set Order"
          @click="$refs.orderDialog.show()"
        />
      </div>
    </div>
    <div
      v-if="report.isRemote"
      class="column"
    >
      <div class="text-bold">
        Default Settings
      </div>

      <report-controls
        :report-element="report"
        options-variable="defaultOptions"
        :all-controls="true"
        preview-options-variable="initialOptions"
      />
    </div>
    <icon-picker-dialog
      ref="iconPickerDialog"
      :model="report"
      icon-property="icon"
    />
    <set-display-order-dialog
      ref="orderDialog"
      :list="$_.map(report.controls || [], name => { return { name: $_.startCase(name), value: name } })"
      @reorder="handleReorder"
    />
  </model-form>
</template>

<script>
import { isOptionSet, optionNamesForControlName, unsetOption } from 'src/models/report/Report'
import IconPickerDialog from 'src/modules/admin/components/IconPickerDialog'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import SetDisplayOrderDialog from 'src/modules/admin/components/SetDisplayOrderDialog'
import ReportControls from 'src/modules/admin/report/ReportControls'

export default {
  name: 'ReportForm',
  components: {
    ModelForm,
    IconPickerDialog,
    SetDisplayOrderDialog,
    ReportControls
  },
  emits: ['change'],
  data () {
    return {
      tab: 'default',
      settingControls: []
    }
  },
  context: ['currentUser'],
  created () {
    _.extend(this, { optionNamesForControlName, isOptionSet, unsetOption })
  },
  models: {
    report: {
      reportCategory: 'default',
      user: 'default',

      allControls: 'default',
      controls: 'default',

      reportOptions: 'default',
      defaultOptions: 'default',
      initialOptions: 'default',

      componentNameOptions: 'default',

      possibleOptionsValues: 'default',
      libraryParentId: true,
      receiveLibraryUpdates: true,
      elements: {
        chart: {
          columns: 'default'
        },
        table: {
          columns: 'default'
        },
        widget: {
          columns: 'default',
          sparkline: 'default'
        },
        rawData: 'default'
      }
    },
    reportCategories: 'default'
  },
  methods: {
    show (model, initial) {
      this.$refs.modelForm.show(model, initial)
    },
    isOptionSetOrSetting (options, control) {
      return isOptionSet(options, control) || _.includes(this.settingControls, control)
    },
    toggleControl (options, control) {
      if (this.isOptionSetOrSetting(options, control)) {
        this.settingControls = _.without(this.settingControls, control)
        unsetOption(options, control)
      } else {
        this.settingControls = [...this.settingControls, control]
        options[control] = this.report.initialOptions[control]
      }
    },
    handleReorder ({ reorderedList }) {
      this.report.controls = _.map(reorderedList, 'value')
    }
  }
}

</script>
